import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { FillFilters } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const SerialNumberCodesList = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "B2C3D4E5-F6A7-8901-BCDE-F23456789ABC";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        serialNumber: '',
        customer: '',
        item: '',
        lot: '',
        inTransactionNum: '',
        outTransactionNum: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);

    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].Rowid;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        const buttonUrl = "/wm/codes/serial-number/edit-record?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        if (filters.length === 0) {
            datasource.filter(null);
        }
        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    const handleFormLoad = useCallback(() => {
        // Load any lookup data if needed
    }, []);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'Rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.SerialNumberCodes.GetSerialNumbers}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Edit Serial Number Records
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='C3D4E5F6-A7B8-9012-DEFA-3456789ABCDE'
                                layoutName='WMSerialNumberCodesSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Columns"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    gridRef={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>

                        {/* Visible grid columns — matching the legacy screen */}
                        <Column dataType="string" caption="Record #"   dataField="RecordNumber" />
                        <Column dataType="string" caption="Serial #"   dataField="SerialNumber" />
                        <Column dataType="string" caption="Customer"   dataField="Customer" />
                        <Column dataType="string" caption="Item"       dataField="itemCode" />
                        <Column dataType="string" caption="Lot"        dataField="lotCode" />
                        <Column dataType="string" caption="Sublot"     dataField="subLotCode" />
                        <Column dataType="string" caption="In-Trans #"  dataField="InTransactionNum" />
                        <Column dataType="string" caption="Out-Trans #" dataField="OutTransactionNum" />
                        <Column dataType="string" caption="Reference 2" dataField="UserDefinedReference2" />

                        {/* Optional columns — surfaced via the Columns chooser panel */}
                        <Column dataType="string"   caption="Barcode Lbl"      dataField="BarcodeLabel"            visible={false} />
                        <Column dataType="string"   caption="Created By"       dataField="CreationUserId"          visible={false} />
                        <Column dataType="datetime" caption="Creation Date"    dataField="CreationDateTime"        visible={false} />
                        <Column dataType="string"   caption="Damaged"          dataField="DamageFlag"              visible={false} />
                        <Column dataType="string"   caption="Dmgd Desc"        dataField="DamageDescription"       visible={false} />
                        <Column dataType="number"   caption="Gross Weight"     dataField="GrossWeight"             visible={false} />
                        <Column dataType="string"   caption="In - Trans #"     dataField="inTransactionNumber"     visible={false} />
                        <Column dataType="datetime" caption="In - Trans Dt"    dataField="InTransactionDt"         visible={false} />
                        <Column dataType="datetime" caption="In-Trans Dt"      dataField="InTransactionDate"       visible={false} />
                        <Column dataType="datetime" caption="Last Updated"    dataField="LastUpdateDateTime"      visible={false} />
                        <Column dataType="string"   caption="Last Updated By" dataField="LastUpdateUserId"        visible={false} />
                        <Column dataType="number"   caption="Net Weight"       dataField="NetWeight"               visible={false} />
                        <Column dataType="number"   caption="Original Gross Weight" dataField="OriginalGrossWeight" visible={false} />
                        <Column dataType="number"   caption="Original Net Weight"   dataField="OriginalNetWeight"   visible={false} />
                        <Column dataType="string"   caption="Out - Trans #"    dataField="outTransactionNumber"    visible={false} />
                        <Column dataType="datetime" caption="Out - Trans Dt"   dataField="OutTransactionDt"        visible={false} />
                        <Column dataType="datetime" caption="Out-Trans Dt"     dataField="OutTransactionDate"      visible={false} />
                        <Column dataType="string"   caption="Package ID"       dataField="PackageId"               visible={false} />
                        <Column dataType="string"   caption="Receipt Verified" dataField="ReceiptVerified"         visible={false} />
                        <Column dataType="string"   caption="Shipment Verified" dataField="ShipmentVerified"       visible={false} />
                        <Column dataType="number"   caption="Size 1"           dataField="Size1"                   visible={false} />
                        <Column dataType="number"   caption="Size 2"           dataField="Size2"                   visible={false} />
                        <Column dataType="string"   caption="UD Code 1"        dataField="UserDefinedCode1"        visible={false} />
                        <Column dataType="string"   caption="UD Reference 1"   dataField="UserDefinedReference1"   visible={false} />
                        <Column dataType="string"   caption="UD Reference 3"   dataField="UserDefinedReference3"   visible={false} />
                        <Column dataType="string"   caption="UD Reference 4"   dataField="UserDefinedReference4"   visible={false} />
                        <Column dataType="string"   caption="UD Reference 5"   dataField="UserDefinedReference5"   visible={false} />
                        <Column dataType="string"   caption="Module"           dataField="Module"                  visible={false} />
                        <Column dataType="string"   caption="Record Type"      dataField="RecordType"              visible={false} />
                        <Column dataType="string"   caption="Company ID"       dataField="CompanyId"               visible={false} />
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(SerialNumberCodesList);
